module.exports = __webpack_public_path__ + "img/betasker.55c0d20e.png";